import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const newsFlashApi = createApi({
  reducerPath: "newsFlashApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://fetc.in/api/v1"}),
  
  tagTypes: ["NewsFlash"],
  endpoints: (builder) => ({
    getActiveNewsFlash: builder.query({
      query: () => "/news-flash/active",
      providesTags: ["NewsFlash"],
    }),
    getAllNewsFlashes: builder.query({
      query: () => "/news-flash",
      providesTags: ["NewsFlash"],
    }),
    createNewsFlash: builder.mutation({
      query: (body) => ({
        url: "/news-flash",
        method: "POST",
        body,
      }),
      invalidatesTags: ["NewsFlash"],
    }),
    updateNewsFlash: builder.mutation({
      query: ({ id, data }) => ({
        url: `/news-flash/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: ["NewsFlash"],
    }),
    deleteNewsFlash: builder.mutation({
      query: (id) => ({
        url: `/news-flash/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["NewsFlash"],
    }),
  }),
});

export const {
  useGetActiveNewsFlashQuery,
  useGetAllNewsFlashesQuery,
  useCreateNewsFlashMutation,
  useUpdateNewsFlashMutation,
  useDeleteNewsFlashMutation,
} = newsFlashApi;
